if(!customElements.get('facets-view')) {
  customElements.define('facets-view',
    class  facetsView extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('.facets-view-item');
        this.gridLayoutMobileDefault  = 2;
        this.gridLayoutDesktopDefault  = 4;

        this.init();
      }

      init() {
        let self = this;
        this.items.forEach(item => {
          item.addEventListener('click', function(event) {
            self.changeViewLayout(event.currentTarget);
          })
        });

        this.buildViewLayout();
      }

      buildViewLayout() {
        let viewGridMobile = localStorage.getItem('view-grid-mobile');
        let viewGridDesktop = localStorage.getItem('view-grid-desktop');
        let layout =document.getElementById('ProductGridContainer');

        if(Number(viewGridMobile) !== Number(this.gridLayoutMobileDefault)
          || Number(viewGridDesktop) !== Number(this.gridLayoutDesktopDefault)) {
          this.items.forEach(item => {
            let positionShow = item.dataset.positionShow;
            let gridLayout = item.dataset.gridLayout;
            if(positionShow === 'mobile') {
              if(viewGridMobile) {
                item.classList.remove('active');
                if(gridLayout === viewGridMobile) {
                  item.classList.add('active')
                }
              }
            } else {
              if(viewGridDesktop) {
                item.classList.remove('active');
                if(gridLayout === viewGridDesktop) {
                  item.classList.add('active')
                }
              }
            }
          });

          layout.dataset.gridMobile = viewGridMobile;
          layout.classList.remove(`view-grid-mobile-${this.gridLayoutMobileDefault}`);
          layout.classList.add(`view-grid-mobile-${viewGridMobile}`);

          layout.dataset.gridDesktop = viewGridDesktop;
          layout.classList.remove(`view-grid-desktop-${this.gridLayoutDesktopDefault}`);
          layout.classList.add(`view-grid-desktop-${viewGridDesktop}`);
        }

      }

      changeViewLayout(clickedItem) {
        let positionShow = clickedItem.dataset.positionShow;
        let layout =document.getElementById('ProductGridContainer');
        let gridLayout = clickedItem.dataset.gridLayout;
        let layoutMobileNow = layout.dataset.gridMobile;
        let layoutDesktopNow = layout.dataset.gridDesktop;


        if(positionShow === 'mobile') {
          layout.dataset.gridMobile = gridLayout;
          layout.classList.remove(`view-grid-mobile-${layoutMobileNow}`);
          layout.classList.add(`view-grid-mobile-${gridLayout}`);
          localStorage.setItem('view-grid-mobile', gridLayout);
        } else {
          layout.dataset.gridDesktop = gridLayout;
          layout.classList.remove(`view-grid-desktop-${layoutDesktopNow}`);
          layout.classList.add(`view-grid-desktop-${gridLayout}`);
          localStorage.setItem('view-grid-desktop', gridLayout);
        }

        let elParent = clickedItem.closest('.facets-view-items');
        elParent.querySelector('.facets-view-item.active')?.classList.remove('active');
        clickedItem.classList.add('active');

      }

    }
  )
}